module.exports = __webpack_public_path__ + "img/banner.cc3cbf91.png";